import * as Sentry from '@sentry/vue';

async function lazyLoadSentryIntegrations() {
    // don't load on server
    if (!import.meta.client) return;

    const { replayIntegration } = await import('@sentry/vue');
    Sentry.addIntegration(replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
    }));
}

function getSentryIntegrations() {
    // don't load on server
    if (!import.meta.client) return [];

    const router = useRouter();
    const browserTracing = Sentry.browserTracingIntegration({
        router,
    });

    const vueIntegration = Sentry.vueIntegration({
        tracingOptions: {
            trackComponents: true,
            timeout: 2000,
            hooks: ['activate', 'mount', 'update']
        }
    });

    return [browserTracing, vueIntegration];
}

export default defineNuxtPlugin((nuxtApp) => {
    const { vueApp } = nuxtApp;

    if (useRuntimeConfig().public.sentryDsn) {
        Sentry.init({
            app: [vueApp],
            dsn: useRuntimeConfig().public.sentryDsn,
            integrations: getSentryIntegrations(),
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1,
            beforeSend(event, hint) {
                const exception = hint.originalException || hint.syntheticException;

                if (exception && typeof exception === 'object' && 'statusCode' in exception
                    && exception.statusCode === 401) {
                    return null; // Don't send to Sentry GraphQL 401 errors that are handled by reloadAppIfExpired
                }

                return event;
            }
        });

        // Lazy-load the replay integration to reduce bundle size
        lazyLoadSentryIntegrations();

        return {
            provide: {
                sentrySetContext: Sentry.setContext,
                sentrySetUser: Sentry.setUser,
                sentrySetTag: Sentry.setTag,
                sentryAddBreadcrumb: Sentry.addBreadcrumb,
                sentryCaptureException: Sentry.captureException
            }
        };
    }
});
